import moment from 'moment';
import {
  ColDef,
  GridOptions,
  ValueFormatterParams,
  ValueGetterParams,
} from '@ag-grid-community/core';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { EntityHistoryDto, UserDto } from '@ellf/common-dto';

@Component({
  selector: 'ellf-history-data-grid',
  templateUrl: './history-data-grid.component.html',
  styleUrls: ['./history-data-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HistoryDataGridComponent implements OnInit {
  historyGridOptions: GridOptions = {
    sideBar: null,
    suppressRowClickSelection: false,
    enableBrowserTooltips: true,
    suppressRowDeselection: true,
  };

  @Input()
  users: UserDto[] = [];

  @Input()
  items: EntityHistoryDto<any>[] = [];

  @Input()
  showCreatedDate = true;

  @Input()
  showUserInfo = true;

  @Input()
  additionalColumns: ColDef[] = [];

  @Input()
  selectedHistoryEntity?: any;

  @Output()
  selectedItemChanged = new EventEmitter<any>();

  historyGridColumns?: ColDef[];

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit() {
    this.generateColumns();
  }

  generateColumns() {
    const columns: ColDef[] = [];

    if (this.showCreatedDate) {
      columns.push({
        field: 'createdDate',
        headerName: 'data/ora',
        minWidth: 100,
        valueFormatter: (params: ValueFormatterParams) => {
          if (!params.value) {
            return '';
          }
          return moment(params.value).format('DD/MM/YYYY HH:mm');
        },
        valueGetter: (params: ValueGetterParams) => {
          const field = params.colDef.field as string;
          const data = field
            .split('.')
            .reduce((p, c) => (p && p[c]) || null, params.data);
          if (data) {
            return moment(data).toDate();
          } else {
            return null;
          }
        },
        tooltipValueGetter: (params) => {
          if (!params.value) {
            return '';
          }
          return moment(params.value).format('LLL');
        },
      });
    }

    if (this.showUserInfo) {
      columns.push({
        headerName: 'utente',
        valueGetter: (p: ValueGetterParams) =>
          this.users.length
            ? this.users.find((u) => u.id === p.data.createdUserId)?.email
            : p.data.createdUser?.email,
        minWidth: 100,
      });
    }

    this.historyGridColumns = [
      ...columns,
      ...this.additionalColumns,
    ] as ColDef[];
  }

  onSelectionChange(items: any[]) {
    const selectedItem = items.length ? items[0] : undefined;

    if (selectedItem) this.selectedItemChanged.emit(selectedItem);
  }
}
